<article class="w-full h-full p-2 md:p-3">
  <p-panelMenu [model]="items" styleClass="w-full md:w-30rem"/>
</article>
